"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var loader_exports = {};
__export(loader_exports, {
  createOpenApiLoader: () => createOpenApiLoader,
  maxSpecBytes: () => maxSpecBytes,
  openApiLoader: () => openApiLoader
});
module.exports = __toCommonJS(loader_exports);
var import_parser = require("./parser");
var import_source = require("./source");
const maxSpecBytes = 8 * 1024 * 1024;
function createOpenApiLoader(options = {}) {
  const settled = /* @__PURE__ */ new Map();
  const inFlight = /* @__PURE__ */ new Map();
  const doFetch = options.fetch ?? defaultFetch;
  const loadUrl = /* @__PURE__ */ __name(async (source, url) => {
    const fetched = await fetchSpecText(url, doFetch);
    if (fetched.error !== void 0) {
      return { source, error: fetched.error };
    }
    const parsed = (0, import_parser.parseOpenApiSpec)(fetched.text ?? "");
    return { source, loadedFrom: url, document: parsed.document, error: parsed.error };
  }, "loadUrl");
  return {
    async load(text) {
      const source = (0, import_source.classifyOpenApiSource)(text);
      if (source.kind !== "url" || source.url === void 0) {
        return parseInline(source);
      }
      const url = source.url;
      const known = settled.get(url);
      if (known !== void 0) return { ...known, source };
      const running = inFlight.get(url);
      if (running !== void 0) {
        const result = await running;
        return { ...result, source };
      }
      const promise = loadUrl(source, url).then((result) => {
        settled.set(url, result);
        return result;
      }).finally(() => {
        inFlight.delete(url);
      });
      inFlight.set(url, promise);
      return await promise;
    },
    peek(text) {
      const source = (0, import_source.classifyOpenApiSource)(text);
      if (source.kind !== "url" || source.url === void 0) {
        return parseInline(source);
      }
      const known = settled.get(source.url);
      return known !== void 0 ? { ...known, source } : void 0;
    },
    forget(url) {
      if (url === void 0) {
        settled.clear();
      } else {
        settled.delete(url);
      }
    }
  };
}
__name(createOpenApiLoader, "createOpenApiLoader");
function parseInline(source) {
  if (source.kind === "empty") {
    return { source };
  }
  const parsed = (0, import_parser.parseOpenApiSpec)(source.text);
  return { source, document: parsed.document, error: parsed.error };
}
__name(parseInline, "parseInline");
async function fetchSpecText(url, doFetch) {
  if (!isHttpUrl(url)) {
    return { error: { kind: "load", message: "Only http and https addresses can be loaded." } };
  }
  let response;
  try {
    response = await doFetch(url, {
      // No cookie, no authorization header, on any origin. See the note at the top.
      credentials: "omit",
      mode: "cors",
      redirect: "follow",
      headers: { accept: "application/json, application/yaml, text/yaml, text/plain, */*" }
    });
  } catch {
    return {
      error: {
        kind: "load",
        message: `Could not load ${url}. The request failed, which is also what happens when the server does not allow cross-origin requests (CORS).`
      }
    };
  }
  if (!response.ok) {
    const statusText = response.statusText !== "" ? ` ${response.statusText}` : "";
    return { error: { kind: "load", message: `Could not load ${url}: HTTP ${response.status}${statusText}.` } };
  }
  const declared = Number(response.headers?.get?.("content-length") ?? "");
  if (Number.isFinite(declared) && declared > maxSpecBytes) {
    return { error: { kind: "load", message: `The specification at ${url} is too large to show.` } };
  }
  let text;
  try {
    text = await response.text();
  } catch {
    return { error: { kind: "load", message: `Could not read the response from ${url}.` } };
  }
  if (text.length > maxSpecBytes) {
    return { error: { kind: "load", message: `The specification at ${url} is too large to show.` } };
  }
  return { text };
}
__name(fetchSpecText, "fetchSpecText");
function isHttpUrl(url) {
  try {
    const parsed = new URL(url);
    return parsed.protocol === "http:" || parsed.protocol === "https:";
  } catch {
    return false;
  }
}
__name(isHttpUrl, "isHttpUrl");
function defaultFetch(input, init) {
  if (typeof fetch !== "function") {
    return Promise.reject(new Error("fetch is not available"));
  }
  return fetch(input, init);
}
__name(defaultFetch, "defaultFetch");
const openApiLoader = createOpenApiLoader();
//# sourceMappingURL=loader.js.map
